import { render, staticRenderFns } from "./exhibition-info-list.vue?vue&type=template&id=837cd4c8&scoped=true&"
import script from "./exhibition-info-list.vue?vue&type=script&lang=js&"
export * from "./exhibition-info-list.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-info-list.vue?vue&type=style&index=0&id=837cd4c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837cd4c8",
  null
  
)

export default component.exports